/* eslint-disable no-unused-vars */
import { useRef, useId, useMemo } from 'react';
import * as S from './UpdateBidPopUp.styled';
import { Buttons, Label, Bid, Loader } from 'components';
import { useSignal } from '@preact/signals-react';
import { useParams } from 'react-router-dom';
import { isBidErrorShown, isInvalidBid, trimDecimal } from 'utils';

export const UpdateBidPopUp = ({
  pba_number,
  onClose,
  // changeBidAction,
  location,
  defaultBid,
  onSetBid,
  minBid,
  displayMinBid = minBid,
  maxBid,
  isCpm,
  isAppDataLoading,
  isBulcActions,
  // isAdmin,
}) => {
  const { cmp_id } = useParams();
  const saveBtn = useId();
  const closeBtn = useId();
  const changeFlag = useRef(true);
  const prevBid = defaultBid ?? minBid;
  const bidValue$ = useSignal(prevBid);

  function handleSave() {
    const bidToSave = bidValue$.value.toString().startsWith('.')
      ? trimDecimal('0' + bidValue$.value)
      : bidValue$.value;

    if (isInvalidBid(bidValue$.value, prevBidToCheck, minBid, maxBid)) return;

    onSetBid(bidToSave);
    onClose();
  }

  const handleBlur = (e) => {
    const currentBid = e.target.value;
    if (currentBid.startsWith('.')) {
      bidValue$.value = trimDecimal('0' + currentBid);
    }
  };

  const handleBidChange = (e) => {
    const newValue = trimDecimal(e.target.value, isCpm);

    // const validValue = e.target.value.match(/^\d*\.?\d{0,3}$/);
    changeFlag.current = newValue ? false : true;
    bidValue$.value = newValue;
  };

  const errorMessage = useMemo(() => {
    if (bidValue$.value < displayMinBid) return `Minimum bid is $${displayMinBid}`;
    if (bidValue$.value > maxBid) return `Bid is too high`;
    return false;
  }, [bidValue$.value, displayMinBid, maxBid]);

  const prevBidToCheck = isBulcActions ? 0 : prevBid;

  const isValid = !isInvalidBid(bidValue$.value, prevBidToCheck, minBid, maxBid);
  const isError = isBidErrorShown(bidValue$.value, minBid, maxBid);
  // admin may save below the publisher minimum, but is warned about it (doesn't disable save)
  const isMinBidWarning = isBidErrorShown(bidValue$.value, displayMinBid, maxBid);

  return (
    <S.PopUpBox location={location}>
      <S.FlexWrap>
        <Label
          text='Bid:'
          variant='label'
          style={{
            maxHeight: '40px',
            lineHeight: '40px',
            alignSelf: 'start',
          }}
        />
        <Bid.Big
          value={bidValue$.value}
          onChange={handleBidChange}
          onBlur={handleBlur}
          error={Boolean(errorMessage)}
          errorMesage={isError || isMinBidWarning ? errorMessage : ''}
        />
        {isAppDataLoading && (
          <S.LoaderWrap>
            <Loader.Local delay={300} />
          </S.LoaderWrap>
        )}
        {isAppDataLoading && (
          <S.LoaderWrap>
            <Loader.Local delay={300} />
          </S.LoaderWrap>
        )}
      </S.FlexWrap>
      <S.FlexWrap>
        <Buttons.SecondaryNormal id={closeBtn} onClick={onClose} style={{ width: '100%' }}>
          Cancel
        </Buttons.SecondaryNormal>
        <Buttons.PrimaryNormal
          id={saveBtn}
          onClick={handleSave}
          style={{ width: '100%' }}
          isDisabled={
            !isValid ||
            isAppDataLoading ||
            // Boolean(errorMessage) ||
            (changeFlag.current && !isBulcActions)
          }
        >
          Ok
        </Buttons.PrimaryNormal>
      </S.FlexWrap>
    </S.PopUpBox>
  );
};
